"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  id: 1,
  quote: "Gridspan's preparation of our industrial site was meticulous. Their temporary power setup allowed our construction crews to start three days ahead of schedule without a single safety incident.",
  author: "Robert Sterling",
  company: "Sterling Construction Group",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/client_robert_sterling.png"
}, {
  id: 2,
  quote: "The precision in their distribution board layouts is unmatched. They don't just install; they engineer a foundation that makes our final wiring phase incredibly straightforward.",
  author: "Marcus Thorne",
  company: "Thorne Industrial Systems",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/client_marcus_thorne.png"
}, {
  id: 3,
  quote: "Reliable infrastructure is the backbone of our manufacturing plants. Gridspan delivered a robust electrical groundwork that met every stringent safety standard we required.",
  author: "Elena Vance",
  company: "Vance Manufacturing Ltd",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/client_elena_vance.png"
}, {
  id: 4,
  quote: "Their team handled the complex site preparation for our new data center with absolute professionalism. The technical accuracy of their groundwork was vital for our high-voltage needs.",
  author: "Simon Chen",
  company: "Nexus Data Solutions",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/client_simon_chen.png"
}, {
  id: 5,
  quote: "From the initial site assessment to the final power distribution setup, Gridspan proved why they are leaders in electrical infrastructure. A truly seamless installation experience.",
  author: "Julian Venter",
  company: "Venter Mining Operations",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/client_julian_venter.png"
}];
export default function Testimonials() {
  return;
}